import React from "react"
import { Card, CardContent, Typography, Box, useTheme } from "@mui/material"
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    Tooltip,
    ResponsiveContainer,
    Cell,
} from "recharts"

export default function FailedSalesByReasonChart({
    title = "Perda de vendas por motivo",
    data = [],
}) {
    const theme = useTheme()
    const colors = [
        theme.palette.error.main,
        theme.palette.warning.main,
        theme.palette.info.main,
        theme.palette.secondary.main,
        theme.palette.primary.main,
    ]

    return (
        <Card sx={{ borderRadius: 1, boxShadow: 1 }}>
            <CardContent>
                <Typography variant="h6" color="text.secondary" gutterBottom>
                    {title}
                </Typography>

                <Box sx={{ height: 300 }}>
                    <ResponsiveContainer width="100%" height="100%">
                        <BarChart
                            data={data}
                            layout="vertical"
                            margin={{
                                top: 10,
                                right: 20,
                                left: 40,
                                bottom: 10,
                            }}
                        >
                            <XAxis type="number" />
                            <YAxis
                                type="category"
                                dataKey="reason"
                                tick={{ fontSize: 12 }}
                                width={150}
                            />
                            <Tooltip
                                formatter={(value) => [
                                    `${value}`,
                                    "Quantidade",
                                ]}
                                contentStyle={{
                                    backgroundColor:
                                        theme.palette.background.paper,
                                    borderColor: theme.palette.divider,
                                }}
                            />
                            <Bar
                                dataKey="value"
                                radius={[0, 8, 8, 0]}
                                isAnimationActive
                            >
                                {data.map((entry, index) => (
                                    <Cell
                                        key={`cell-${index}`}
                                        fill={colors[index % colors.length]}
                                    />
                                ))}
                            </Bar>
                        </BarChart>
                    </ResponsiveContainer>
                </Box>
            </CardContent>
        </Card>
    )
}
